export default __webpack_public_path__ + "static/media/inspiration6.a65339f0.jpg";